import { observer } from 'mobx-react';
import { RealizedLossForm } from './RealizedLossForm';
import { CustomTaskDialog } from '@roc/feature-general-tasks';
import { StandardDialog } from '@roc/ui';
import { Document as DocumentType } from '@roc/feature-types';

export type RealizedLossItemProps = {
  open: boolean;
  onClose: () => void;
  loanId?: string;
  document?: DocumentType;
};

export const RealizedLossItem = observer(
  ({ open, onClose, loanId, document }: RealizedLossItemProps) => {
    const dialogContent = (
      <RealizedLossForm
        handleClose={onClose}
        loanId={loanId != null ? Number(loanId) : undefined}
      />
    );

    return (
      <>
        {document?.taskId ? (
          <CustomTaskDialog
            open={open}
            title="Realized Interest And Principal Loss"
            handleClose={onClose}
            dialogContent={dialogContent}
            taskId={document.taskId}
          />
        ) : (
          <StandardDialog
            open={open}
            title="Realized Interest And Principal Loss"
            maxWidth="sm"
            handleClose={onClose}
            dialogContent={dialogContent}
          />
        )}
      </>
    );
  }
);

export default RealizedLossItem;
